/* eslint-disable @typescript-eslint/no-this-alias */
import { Graph, registerBehavior } from '@antv/g6'
import { GraphStates } from './utils'

export function registerRemoveEdgeBehavior(): void {
  registerBehavior('remove-edge', {
    getEvents() {
      return {
        keydown: 'onKeyDown',
      }
    },

    onKeyDown(e: KeyboardEvent) {
      const graph = this.graph as Graph

      const code = e.key
      if (code === 'Delete' || code === 'Backspace') {
        const selectedEdges = graph.findAllByState('edge', GraphStates.Selected)
        if (selectedEdges.length > 0) {
          selectedEdges.forEach((edge) => {
            graph.emit('beforeremoveedge', {
              edge,
            })
            graph.remove(edge)
            graph.emit('afterremoveedge', {
              edge,
            })
          })
        }
      }
    },
  })
}
